const WHAM_PATHNAME = '/alf/wham/loantype';
const PURCHASE_HOSTNAME = 'mortgage.quickenloans.com';
const REFINANCE_HOSTNAME = 'refinance.quickenloans.com';

export const isValidLeadFormLink = ({ pathname, hostname, hash }) =>
    [WHAM_PATHNAME].includes(pathname.toLowerCase()) ||
    [PURCHASE_HOSTNAME, REFINANCE_HOSTNAME].includes(hostname.toLowerCase()) ||
    hash.toLowerCase().includes('#sourceid');
